(() => {
  'use strict';

  const updateProductVariant = (form) => {
    const selector = form.querySelector('[data-variant-selector]');
    const choice = selector?.selectedOptions[0];
    if (!choice) return;
    const product = form.closest('[data-product-section]');
    const available = choice.dataset.available === 'true';
    const checkoutEnabled = form.dataset.checkoutEnabled === 'true';
    const button = form.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-label]');
    if (button) button.disabled = !available || !checkoutEnabled;
    if (label) label.textContent = !checkoutEnabled ? 'Checkout is being prepared' : available ? 'Add to cart' : 'Sold out';
    const availability = product?.querySelector('[data-availability]');
    if (availability) availability.textContent = !checkoutEnabled ? 'Private preview · Checkout opens after launch.' : available ? 'Available now' : 'This edition is currently unavailable.';
    const price = product?.querySelector('[data-product-price]');
    if (price) price.textContent = choice.dataset.price || '';
    const compare = product?.querySelector('[data-compare-price]');
    if (compare) {
      compare.textContent = choice.dataset.comparePrice || '';
      compare.hidden = !choice.dataset.comparePrice;
    }
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) {
      const min = Number(choice.dataset.quantityMin || 1);
      const step = Number(choice.dataset.quantityStep || 1);
      quantity.min = String(min);
      quantity.step = String(step);
      if (choice.dataset.quantityMax) quantity.max = choice.dataset.quantityMax;
      else quantity.removeAttribute('max');
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const current = Number(quantity.value) || min;
      quantity.value = String(Math.min(max, Math.max(min, min + Math.round((current - min) / step) * step)));
      quantity.disabled = !available;
    }
    const image = product?.querySelector('[data-product-image]');
    if (image && choice.dataset.image) {
      image.src = choice.dataset.image;
      image.removeAttribute('srcset');
      image.alt = choice.dataset.imageAlt || image.alt;
    }
    const acceleratedCheckout = form.querySelector('[data-payment-container]');
    if (acceleratedCheckout) acceleratedCheckout.hidden = !available || !checkoutEnabled;
    if (!document.documentElement.classList.contains('shopify-design-mode')) {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', choice.value);
      window.history.replaceState({}, '', nextUrl);
    }
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-feature-carousel]').forEach((carousel) => {
      if (carousel.dataset.rmbInitialized) return;
      carousel.dataset.rmbInitialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-feature-slide]')];
      const dots = [...carousel.querySelectorAll('[data-feature-dot]')];
      let index = 0;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        const status = carousel.querySelector('[data-feature-status]');
        if (status) status.textContent = `${index + 1} of ${slides.length}`;
      };
      carousel.querySelector('[data-feature-prev]')?.addEventListener('click', () => show(index - 1));
      carousel.querySelector('[data-feature-next]')?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
    scope.querySelectorAll('[data-card-preview]').forEach((button) => {
      if (button.dataset.rmbInitialized) return;
      button.dataset.rmbInitialized = 'true';
      const audio = button.closest('.rmb-product-card-visual')?.querySelector('[data-card-audio]');
      if (!audio) return;
      const update = () => {
        button.setAttribute('aria-pressed', String(!audio.paused));
        button.querySelector('.rmb-preview-play').hidden = !audio.paused;
        button.querySelector('.rmb-preview-pause').hidden = audio.paused;
        button.setAttribute('aria-label', `${audio.paused ? 'Play' : 'Pause'} ${audio.getAttribute('aria-label')}`);
      };
      button.addEventListener('click', () => {
        if (audio.paused) audio.play().catch(() => {
          button.setAttribute('aria-label', 'Preview unavailable. Open the pack to listen.');
          update();
        });
        else audio.pause();
      });
      audio.addEventListener('play', update);
      audio.addEventListener('pause', update);
      audio.addEventListener('ended', update);
    });
    scope.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.rmbInitialized) return;
      form.dataset.rmbInitialized = 'true';
      form.querySelector('[data-variant-selector]')?.addEventListener('change', () => updateProductVariant(form));
      form.addEventListener('submit', (event) => {
        const selector = form.querySelector('[data-variant-selector]');
        const choice = selector?.selectedOptions[0];
        if (form.dataset.checkoutEnabled !== 'true' || (choice && choice.dataset.available !== 'true')) event.preventDefault();
      });
    });
    scope.querySelectorAll('[data-cart-form]').forEach((form) => {
      if (form.dataset.rmbInitialized) return;
      form.dataset.rmbInitialized = 'true';
      form.addEventListener('submit', (event) => {
        if (form.dataset.checkoutEnabled !== 'true' && event.submitter?.name === 'checkout') event.preventDefault();
      });
    });
    scope.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
      if (thumbnail.dataset.rmbInitialized) return;
      thumbnail.dataset.rmbInitialized = 'true';
      thumbnail.addEventListener('click', () => {
        const product = thumbnail.closest('[data-product-section]');
        const image = product?.querySelector('[data-product-image]');
        if (!image) return;
        image.src = thumbnail.dataset.image;
        image.removeAttribute('srcset');
        image.alt = thumbnail.dataset.imageAlt || '';
        product.querySelectorAll('[data-product-thumbnail]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumbnail)));
      });
    });
    scope.querySelectorAll('[data-collection-sort]').forEach((selector) => {
      if (selector.dataset.rmbInitialized) return;
      selector.dataset.rmbInitialized = 'true';
      selector.addEventListener('change', () => {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', selector.value);
        nextUrl.searchParams.delete('page');
        window.location.assign(nextUrl.toString());
      });
    });
    scope.querySelectorAll('audio').forEach((audio) => {
      if (audio.dataset.rmbInitialized) return;
      audio.dataset.rmbInitialized = 'true';
      audio.addEventListener('play', () => document.querySelectorAll('audio').forEach((other) => { if (other !== audio) other.pause(); }));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
